import FetchTemplateCategories from '@/connection/categories/fetch-template-categories';
import { RootState } from '@/store/main';
import { UserState } from '../../user/types';
import { TemplatesReducerCreator, TemplatesState } from '../types';

const fetchTemplateCategoriesReducer = (create: TemplatesReducerCreator) => {
  return create.asyncThunk(
    ({ channel }: { channel?: number }, { getState }) => {
      const state = getState() as RootState;
      const templatesSlice = state.templates as TemplatesState;
      if (templatesSlice?.categoryFilters) {
        return templatesSlice.categoryFilters;
      }
      const userState = state.user as UserState;
      const activeChannel = userState.user?.active_channel;
      const _channel = channel ?? activeChannel ?? Number(import.meta.env.VITE_GLOBAL_TEMPLATES_CHANNEL);
      return FetchTemplateCategories({ channel: _channel });
    },
    {
      pending: (state) => {
        state.loadingTemplateCategoryFilters = true;
      },
      fulfilled: (state, action) => {
        state.categoryFilters = action.payload;
        state.loadingTemplateCategoryFilters = false;
      },
      rejected: (state, action) => {
        console.error(action.error);
        state.loadingTemplateCategoryFilters = false;
      },
    }
  );
};

export default fetchTemplateCategoriesReducer;
